import Cookies from "js-cookie";

const actions = {
  async authCreate(context, payload) {
    try {
      const { data, captchaToken } = payload;
      this.$axios.setHeader("X-Captcha-Token", captchaToken);

      const response = await this.$api.call("auth.create", { data });
      const responseData = response.data;

      // Multiple Organization Case
      if (responseData.organizations && responseData.organizations.length > 1) {
        context.commit("mutationUserOrganizations", responseData.organizations);
        return responseData;
      }

      // Single Organization Case
      if (responseData.user) {
        context.commit("mutationUserOrganizations", [
          { ...responseData.user.organizations },
        ]);
        context.commit("mutationAuthCreate", responseData);

        return responseData;
      }

      return responseData;
    } catch (error) {
      context.commit("mutationAuthCreate", {});
      context.dispatch("authDestroy");

      throw error;
    } finally {
      this.$axios.setHeader("X-Captcha-Token", null);
    }
  },

  async authRefresh(context, payload) {
    try {
      if (!Cookies.get("r")) {
        context.dispatch("authDestroy");
        return;
      }

      const { data } = await this.$axios.post("/user/v1/v2/sessions/refresh", {
        refresh: payload.data.refresh,
      });
      const responseData = data.data;

      context.commit("mutationAuthCreate", responseData);

      return responseData;
    } catch (error) {
      context.commit("mutationAuthCreate", {});
      context.dispatch("authDestroy");

      throw error;
    }
  },

  intervalToken(context, payload) {
    const TIMEOUT = 10 * 60 * 1000; // 25 mins for 30 mins ttl token
    clearTimeout(context.state.callRefreshToken);

    context.state.callRefreshToken = setTimeout(() => {
      context.dispatch("authRefresh", payload);
    }, TIMEOUT);
  },

  async authDestroy(context) {
    try {
      const r = Cookies.get("r");
      if (r !== undefined && r !== "") {
        this.$axios.delete(`/user/v1/v2/sessions/${Cookies.get("r")}`);
      }

      if (localStorage.getItem("lastRefresh")) {
        localStorage.removeItem("lastRefresh");
      }

      context.commit("mutationAuthDestroy");
      context.dispatch("appPersisted/destroyStates", null, { root: true });

      const partnerCode = process.env.PARTNER_CODE;
      // if partnerCode is not GENERAL, set color theme to partnerCode.toLocaleLowerCase()
      if (partnerCode && partnerCode !== "GENERAL") {
        context.dispatch(
          "appPersisted/setColorTheme",
          partnerCode.toLocaleLowerCase(),
          { root: true },
        );
      } else {
        // if partnerCode is GENERAL, set color theme to black-and-white
        context.dispatch("appPersisted/setColorTheme", "black-and-white", {
          root: true,
        });
      }

      clearTimeout(context.state.callRefreshToken);

      await this.$router.push("/");
    } catch (error) {
      //context.commit("mutationAuthCreate", {});
      context.dispatch(
        "app/toggleSnackBar",
        {
          message: `Something went wrong. ${error?.message}`,
          color: "invert-error",
          isNoSidebarToolbar: true,
        },
        {
          root: true,
        },
      );
      await this.$router.push("/");
    }
  },

  async authCreateGoogleSSO(context, payload) {
    try {
      const { data, captchaToken } = payload;

      this.$axios.setHeader("X-Captcha-Token", captchaToken);

      const response = await this.$api.call("auth.createSSO", { data });

      const responseData = response.data;

      // Multiple Organization Case
      if (responseData.organizations && responseData.organizations.length > 1) {
        context.commit("mutationUserOrganizations", responseData.organizations);
        return responseData;
      }

      // Single Organization Case
      if (responseData.user) {
        context.commit("mutationUserOrganizations", [
          { ...responseData.user.organizations },
        ]);
        context.commit("mutationAuthCreate", responseData);

        return responseData;
      }

      return responseData;
    } catch (error) {
      context.commit("mutationAuthCreate", {});
      context.dispatch("authDestroy");

      throw error;
    } finally {
      this.$axios.setHeader("X-Captcha-Token", null);
    }
  },
};

export default actions;
